<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Approval Progress
    </div>
    <div class="enterprise-network_container_table">
      <div class="node-diagram-wrap">
        <div
          class="node-diagram-content"
          :style="{
            minWidth: nodeList.length * 126 - 52 + 'px'
          }"
        >
          <div
            v-for="(item, index) in nodeList"
            class="node-diagram-item"
            :class="{
              'node-diagram-item_start': index === 0,
              'node-diagram-item': index > 0 && index < nodeList.length - 1,
              'node-diagram-item_end': index === nodeList.length - 1,
              [`node-diagram-status_${item.nodeState}`]: true
            }"
          >
            <div class="node-diagram-icon">
              <!--开始-->
              <svg
                v-if="index === 0"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                xml:space="preserve"
                version="1.1"
              >
                <path
                  stroke="null"
                  id="svg_2"
                  fill="#C7C7C7"
                  d="m7.51294,18.79226c0.32293,0.17834 0.68442,0.26991 1.05073,0.26991c0.44825,-0.00482 0.89168,-0.13978 1.26763,-0.38559l6.78638,-4.47284c0.7519,-0.49645 1.19533,-1.33993 1.18569,-2.23642c0.01446,-0.8724 -0.41933,-1.6966 -1.14713,-2.17858l-6.84422,-4.4632c-0.69406,-0.47235 -1.59056,-0.51573 -2.328,-0.11568c-0.81938,0.48199 -1.31101,1.37366 -1.28691,2.328l0,8.93123c-0.0241,0.95434 0.48199,1.85083 1.31583,2.32318l0,0zm0,0"
                />
              </svg>
              <!--已完成-->
              <svg
                v-if="
                  index > 0 &&
                    index !== nodeList.length - 1 &&
                    item.nodeState === 1
                "
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
              >
                <g>
                  <title>Layer 1</title>
                  <path
                    id="svg_1"
                    fill="none"
                    d="m-50.52632,6l48,0l0,48l-48,0l0,-48z"
                  />
                  <path
                    stroke="null"
                    id="svg_2"
                    d="m8.7914,15.87883l-4.17144,-4.17144l-1.41549,1.41549l5.58692,5.58692l12.00413,-12.00413l-1.41549,-1.41549l-10.58864,10.58864z"
                  />
                </g>
              </svg>
              <!-- 未开始， 当前节点 -->
              <svg
                v-if="
                  index > 0 &&
                    index !== nodeList.length - 1 &&
                    item.nodeState !== 1
                "
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                version="1.1"
                xml:space="preserve"
              >
                <g id="svg_1" stroke="null" transform="rotate(45 12 12)">
                  <path
                    id="svg_2"
                    d="m0.26087,0.26087l23.47826,0l0,23.47826l-23.47826,0l0,-23.47826z"
                    fill="none"
                    stroke="null"
                  />
                  <path
                    id="svg_3"
                    d="m9.06522,5.15217l0,1.95652l6.44185,0l-11.33315,11.33315l1.38424,1.38424l11.33315,-11.33315l0,6.44185l1.95652,0l0,-9.78261l-9.78261,0z"
                    stroke="null"
                  />
                </g>
              </svg>
              <svg
                v-if="index === nodeList.length - 1"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                version="1.1"
                xml:space="preserve"
              >
                <g>
                  <path
                    id="svg_4"
                    d="m4,8c0,-2.17352 1.82648,-4 4,-4l8,0c2.17352,0 4,1.82648 4,4l0,8c0,2.17352 -1.82648,4 -4,4l-8,0c-2.17352,0 -4,-1.82648 -4,-4l0,-8z"
                    opacity="undefined"
                  />
                  <rect
                    id="svg_5"
                    height="0.37037"
                    width="3.33333"
                    y="-8.18519"
                    x="71.44445"
                  />
                </g>
              </svg>
            </div>

            <el-tooltip :content="item.nodeName">
              <div slot="content">{{ item.nodeName }}</div>
              <div class="node-diagram-text">{{ item.nodeName }}</div>
            </el-tooltip>
          </div>
        </div>
        <div
          class="node-diagram-line"
          :style="{
            minWidth: (nodeList.length - 1) * 126 + 'px'
          }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "enterpriseNetworkNodeDiagram",
  props: {
    /**
     * 节点数据
     */
    nodeList: {
      type: Array,
      default: () => [
        {
          nodeName: "Application",
          nodeState: 1
        },
        {
          nodeName: "Approval by Ruijie Country Manager",
          nodeState: 1
        },
        {
          nodeName: "Approval by Ruijie Country Manager",
          nodeState: 1
        },
        {
          nodeName: "Approval by Regional Manager",
          nodeState: 1
        },
        {
          nodeName: "Approval by Assitant",
          nodeState: 1
        },
        {
          nodeName: "Channel Confirmation",
          nodeState: 1
        },
        {
          nodeName: "End",
          nodeState: 1
        }
      ]
    }
  }
};
</script>

<style scoped>
.node-diagram-wrap {
  background: white;
  overflow-y: hidden;
  padding-top: 20px;
  position: relative;
}

.node-diagram-line {
  width: calc(100% - 44px);
  height: 0;
  border-top: 1px dashed rgba(198, 199, 199, 1);
  top: 44px;
  left: 24px;
  position: absolute;
  z-index: 2;
}

.node-diagram-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.node-diagram-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 11px;
}

.node-diagram-icon {
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid rgba(198, 199, 199, 1);
  z-index: 3;
}

.node-diagram-item_start {
  margin-left: -26px;
}

.node-diagram-item_end {
  margin-right: -26px;
}

.node-diagram-icon svg {
  width: 24px;
  fill: #c7c7c7;
  height: 24px;
}

.node-diagram-text {
  width: 128px;
  height: 60px;
  text-align: center;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制在三行 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.node-diagram-status_1 .node-diagram-icon {
}

.node-diagram-status_0 .node-diagram-icon {
  border-color: #e60039;
}

.node-diagram-status_0 .node-diagram-icon svg {
  fill: #e60039;
}

.node-diagram-status_2 .node-diagram-icon {
  border-color: #e60039;
  background: #e60039;
}

.node-diagram-status_2 .node-diagram-icon svg {
  fill: #ffffff;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/nodeDiagram.vue